/* ==========================================================================
   Stacks: Choose Your Path — section JS
   Reads runtime config from <script type="application/json" data-cp-config> rendered by Liquid.
   BYO tab: product grid multi-select with discount tiers.
   ========================================================================== */
(function () {
  function init(root) {
    if (!root || root.dataset.cpInit === '1') return;
    root.dataset.cpInit = '1';

    /* Highlight discount percentages in rules text if not already wrapped in <strong> */
    root.querySelectorAll('.byo__rules-item span:not(.byo__bolt)').forEach(function (el) {
      if (!el.querySelector('strong')) {
        el.innerHTML = el.textContent.replace(/(\d+%)/g, '<strong>$1</strong>');
      }
    });

    /* --- Read config from rendered Liquid --- */
    const configEl = root.querySelector('script[data-cp-config]');
    let cfg = {};
    try { cfg = JSON.parse((configEl && configEl.textContent) || '{}'); } catch (e) {}

    /* --- Header tabs (Curated / BYO) --- */
    const tabs = root.querySelectorAll('.choose-path__tab');
    const panels = root.querySelectorAll('.choose-path__panel');
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.getAttribute('data-target');
        tabs.forEach(t => {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active);
        });
        panels.forEach(p => p.classList.toggle('is-active', p.getAttribute('data-panel') === target));
      });
    });

    /* --- Curated form submit (server-side cart add) --- */
    root.querySelectorAll('.bundle-card__form').forEach(form => {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const btn = form.querySelector('.bundle-card__button');
        if (btn.disabled) return;
        const original = btn.innerHTML;
        btn.innerHTML = 'Adding...';
        btn.disabled = true;

        // One-time purchases keep the native bundle submission (bundle product
        // + Avada bundle quantity/discount inputs). Only subscription stacks
        // are split into component line items.
        const isSubscribe = !!form.querySelector('.bundle-card__option--subscribe.is-active');
        let stackItems = [];
        if (isSubscribe) {
          try {
            stackItems = buildStackItemsFromForm(form);
          } catch (error) {
            console.error(error);
            btn.innerHTML = 'Error';
            setTimeout(() => { btn.innerHTML = original; btn.disabled = false; }, 2000);
            return;
          }
        }
        let fetchOptions;
        if (stackItems.length) {
          fetchOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: stackItems,
              sections: 'cart-drawer,cart-icon-bubble',
              sections_url: window.location.pathname
            })
          };
        } else {
          const formData = new FormData(form);
          formData.append('sections', 'cart-drawer,cart-icon-bubble');
          formData.append('sections_url', window.location.pathname);
          fetchOptions = { method: 'POST', body: formData };
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', fetchOptions)
          .then(r => { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(data => {
            btn.innerHTML = original;
            btn.disabled = false;
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
              cartDrawer.renderContents(data);
            } else {
              window.location.href = window.Shopify.routes.root + 'cart';
            }
          })
          .catch(() => {
            btn.innerHTML = 'Error';
            setTimeout(() => { btn.innerHTML = original; btn.disabled = false; }, 2000);
          });
      });
    });

    /* --- BYO Grid --- */
    const dRoot = root.querySelector('.byo--desktop');
    if (!dRoot) return;
    initGrid(root, dRoot, cfg);
  }

  function syncStackComponentVariants(form) {
    const idInput = form.querySelector('input[name=id]');
    const mapEl = form.querySelector('[data-stack-variant-map]');
    if (!idInput || !mapEl) return;
    let entry;
    try {
      entry = JSON.parse(mapEl.textContent)[idInput.value];
    } catch (e) {
      return;
    }
    if (!entry) return;
    const inputs = Array.from(form.querySelectorAll('[data-stack-component-variant-id]'));
    Object.keys(entry).forEach((index) => {
      const input = inputs[Number(index)];
      if (!input) return;
      if (entry[index].id) input.value = String(entry[index].id);
      if (entry[index].available !== undefined) input.dataset.stackComponentAvailable = String(entry[index].available);
    });
  }

  function buildStackItemsFromForm(form) {
    // Follow the flavors encoded in the card's bundle variant (default
    // selection on hub cards) instead of each child's first variant.
    syncStackComponentVariants(form);

    const componentInputs = Array.from(form.querySelectorAll('[data-stack-component-variant-id]'));
    if (form.hasAttribute('data-stack-form') && !componentInputs.length) {
      throw new Error('stack components missing');
    }
    if (!componentInputs.length) return [];

    const unavailable = componentInputs.find(input => input.dataset.stackComponentAvailable === 'false');
    if (unavailable) {
      throw new Error(`${unavailable.dataset.stackComponentTitle || 'A stack item'} is unavailable`);
    }

    const sellingPlanId = parseInt((form.querySelector('.selling-plan-input') || {}).value || '', 10);
    if (form.querySelector('.bundle-card__option--subscribe.is-active') && !sellingPlanId) {
      throw new Error('selling plan missing');
    }

    const stackTitle = form.dataset.stackTitle || form.querySelector('.bundle-card__title')?.textContent?.trim() || 'Stack';
    const formData = new FormData(form);
    const stackHandle = form.dataset.stackHandle || formData.get('id') || 'stack';
    const stackVariantId = formData.get('id') || stackHandle;
    const stackSellingPlanKey = sellingPlanId ? String(sellingPlanId) : 'no-plan';
    const stackImage = form.dataset.stackImage || '';
    // Stable per stack variant + selling plan: identical flavor/frequency
    // adds merge, but different variants or frequencies stay separate.
    const groupKey = `${stackHandle}:${stackVariantId}:${stackSellingPlanKey}`;

    return componentInputs.map((input, index) => {
      const item = {
        id: parseInt(input.value, 10),
        quantity: parseInt(input.dataset.stackComponentQuantity || '1', 10) || 1,
        properties: {
          _stack_id: stackHandle,
          _stack_title: stackTitle,
          Bundle: stackTitle,
          _stack_group_key: groupKey,
          _stack_component_index: String(index + 1),
          _stack_variant_id: String(stackVariantId),
          _stack_selling_plan_id: stackSellingPlanKey,
        },
      };

      if (input.dataset.stackComponentHandle) item.properties._stack_component_handle = input.dataset.stackComponentHandle;
      if (input.dataset.stackComponentTitle) item.properties._stack_component_title = input.dataset.stackComponentTitle;
      if (input.dataset.stackComponentImage) item.properties._stack_component_image = input.dataset.stackComponentImage;
      if (stackImage) item.properties._stack_image = stackImage;
      if (sellingPlanId) item.selling_plan = sellingPlanId;

      return item;
    }).filter(item => item.id);
  }

  function initGrid(root, dRoot, cfg) {
    const currency = cfg.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AED';
    const discountTwo = Number(cfg.discount_two_items) || 10;
    const discountThree = Number(cfg.discount_three_plus) || 15;
    const discountSubscribe = Number(cfg.discount_subscribe) || 19;
    const sellingPlanId = cfg.byo_selling_plan_id || '';
    const subscribeCode2 = cfg.subscribe_discount_code_2 || '';
    const subscribeCode3 = cfg.subscribe_discount_code_3 || '';
    const savePrefix = cfg.save_banner_prefix || '';
    const saveSuffix = cfg.save_banner_suffix || '';
    const addToCartBaseLabel = cfg.add_to_cart_label || 'Add to Cart';

    function fmt(cents) { return `${currency} ${fmtNum(cents)}`; }
    function fmtNum(cents) {
      // Amounts are presentment-currency cents; group thousands like the
      // Liquid money filters do (e.g. "AED 1,234.56").
      return new Intl.NumberFormat('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((cents || 0) / 100);
    }
    function escHtml(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, s => (
        { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[s]
      ));
    }
    function applyDiscountCookie(code) {
      if (!code) return Promise.resolve();
      return fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET', credentials: 'same-origin', redirect: 'manual'
      }).catch(() => {});
    }

    let rhythm = 'subscribe';
    /* Map: productId → { variantId, name, meta, priceCents, imgSrc } */
    const selected = new Map();

    /* --- Rhythm toggle --- */
    dRoot.querySelectorAll('[data-byo-rhythm]').forEach(tab => {
      tab.addEventListener('click', () => {
        rhythm = tab.getAttribute('data-byo-rhythm');
        dRoot.querySelectorAll('[data-byo-rhythm]').forEach(t => {
          t.classList.toggle('is-active', t.getAttribute('data-byo-rhythm') === rhythm);
        });
        renderCart();
      });
    });

    /* --- Product card multi-select --- */
    dRoot.querySelectorAll('[data-byo-pcard]').forEach(card => {
      card.addEventListener('click', () => {
        const id = card.getAttribute('data-product-id');
        if (selected.has(id)) {
          selected.delete(id);
          card.classList.remove('is-selected');
        } else {
          selected.set(id, {
            variantId: card.getAttribute('data-variant-id'),
            name: card.getAttribute('data-name') || '',
            meta: card.getAttribute('data-meta') || '',
            priceCents: parseInt(card.getAttribute('data-price') || 0, 10),
            imgSrc: card.getAttribute('data-image') || '',
            sellingPlanId: card.getAttribute('data-selling-plan-id') || ''
          });
          card.classList.add('is-selected');
        }
        renderCart();
      });
    });

    /* --- Build cart item node --- */
    function buildCartItem(item) {
      const node = document.createElement('div');
      node.className = 'byo__cart-item';
      node.setAttribute('data-byo-cart-item', '');
      const imgHtml = item.imgSrc
        ? `<img src="${escHtml(item.imgSrc)}" alt="${escHtml(item.name)}" loading="lazy">`
        : '';
      node.innerHTML = `
        <div class="byo__cart-item-image">${imgHtml}</div>
        <div class="byo__cart-item-info">
          <p class="byo__cart-item-name">${escHtml(item.name)}</p>
          <p class="byo__cart-item-price">
            <span class="byo__pcard-currency">${escHtml(currency)}</span>
            <span class="byo__pcard-amount">${fmtNum(item.priceCents)}</span>
          </p>
        </div>`;
      return node;
    }

    /* --- Render sidebar cart + totals --- */
    function renderCart() {
      /* Rebuild item list */
      const summaryEl = dRoot.querySelector('[data-byo-summary]');
      const emptyEl = dRoot.querySelector('[data-byo-empty]');
      if (summaryEl) {
        summaryEl.querySelectorAll('[data-byo-cart-item]').forEach(el => el.remove());
        selected.forEach(item => summaryEl.appendChild(buildCartItem(item)));
      }
      const count = selected.size;
      if (emptyEl) emptyEl.style.display = count > 0 ? 'none' : '';

      /* Count badge */
      const countEl = dRoot.querySelector('[data-byo-count]');
      if (countEl) countEl.textContent = count > 0 ? `${count} item${count !== 1 ? 's' : ''} selected` : '';

      /* Discount calculation — NO combine */
      let itemTotal = 0;
      selected.forEach(item => { itemTotal += item.priceCents; });

      let stackDiscount = 0;
      let subBenefit = 0;
      let stackPct = 0;
      let subPct = 0;

      if (rhythm === 'subscribe') {
        /* Subscribe: 19% flat max, regardless of count */
        subBenefit = Math.round(itemTotal * discountSubscribe / 100);
        subPct = discountSubscribe;
      } else {
        /* One-time tier discount */
        if (count >= 3) {
          stackDiscount = Math.round(itemTotal * discountThree / 100);
          stackPct = discountThree;
        } else if (count >= 2) {
          stackDiscount = Math.round(itemTotal * discountTwo / 100);
          stackPct = discountTwo;
        }
      }

      const grand = itemTotal - stackDiscount - subBenefit;
      const saved = stackDiscount + subBenefit;

      /* Update DOM */
      setText('[data-byo-item-total]', fmtNum(itemTotal));
      setText('[data-byo-stack-discount]', fmtNum(stackDiscount));
      setText('[data-byo-sub-benefit]', fmtNum(subBenefit));
      setText('[data-byo-grand]', fmtNum(grand));
      //setText('[data-byo-stack-pct]', '-' + (count >= 3 ? discountThree : discountTwo) + '%');
      setText('[data-byo-stack-pct]', stackPct > 0 ? '-' + stackPct + '%' : '');
      setText('[data-byo-sub-pct]', subPct > 0 ? '-' + subPct + '%' : '');
      setHidden('[data-byo-row-stack]', stackDiscount === 0);
      setHidden('[data-byo-row-sub]', subBenefit === 0);
      setClass('[data-byo-stack-pct]', 'no-discount', stackDiscount === 0);
      setClass('[data-byo-sub-pct]', 'no-discount', subBenefit === 0);
      setHidden('[data-byo-totals-block]', count === 0);
      setHidden('[data-byo-save-banner]', saved === 0);
      if (saved > 0) setText('[data-byo-save-text]', `${savePrefix} ${fmt(saved)} ${saveSuffix}`.trim());

      /* Explains a zero discount: nothing picked yet, or a one-time stack that
         has not reached the 2-item tier. Subscribe mode has no stack discount
         at all, so it explains the flat subscriber discount instead. */
      const isOnetime = rhythm === 'onetime';
      const noteOnetime = dRoot.querySelector('[data-byo-note-onetime]');
      const noteSubscribe = dRoot.querySelector('[data-byo-note-subscribe]');
      const activeNote = isOnetime ? noteOnetime : noteSubscribe;
      const showNote = !!activeNote && activeNote.textContent.trim() !== ''
        && (count === 0 || (isOnetime && stackDiscount === 0));
      if (noteOnetime) noteOnetime.hidden = !showNote || !isOnetime;
      if (noteSubscribe) noteSubscribe.hidden = !showNote || isOnetime;
      setHidden('[data-byo-savings-note]', !showNote);

      const addBtn = dRoot.querySelector('[data-byo-add-cart]');
      if (addBtn) {
        addBtn.disabled = count === 0;
        if (addBtn.dataset.submitting !== '1') addBtn.textContent = addToCartBaseLabel;
      }
    }

    function setText(sel, text) {
      dRoot.querySelectorAll(sel).forEach(el => { if (el) el.textContent = text; });
    }
    function setHidden(sel, hidden) {
      dRoot.querySelectorAll(sel).forEach(el => { if (el) el.hidden = hidden; });
    }
    function setClass(sel, cls, add) {
      dRoot.querySelectorAll(sel).forEach(el => { if (el) el.classList.toggle(cls, add); });
    }

    /* --- Add to Cart submit --- */
    function submitCart() {
      if (selected.size === 0) return;
      const addBtn = dRoot.querySelector('[data-byo-add-cart]');
      if (addBtn) { addBtn.disabled = true; addBtn.dataset.submitting = '1'; addBtn.textContent = 'Adding...'; }

      const count = selected.size;

      /* Determine discount code to apply */
      let activeDiscountCode = '';
      if (rhythm === 'subscribe') {
        /* Subscribe: apply discount code for 19% off (Shopify discount rule)
           AND selling_plan for recurring billing — both are always applied together */
        if (count >= 3 && subscribeCode3) activeDiscountCode = subscribeCode3;
        else if (subscribeCode2) activeDiscountCode = subscribeCode2;
      } else {
        /* One-time: tier discount codes */
        if (count >= 3 && subscribeCode3) activeDiscountCode = subscribeCode3;
        else if (count >= 2 && subscribeCode2) activeDiscountCode = subscribeCode2;
      }

      /* Build cart items — attach per-product selling plan when subscribing */
      const items = [];
      selected.forEach(item => {
        const cartItem = { id: parseInt(item.variantId, 10), quantity: 1 };
        if (rhythm === 'subscribe') {
          const planId = item.sellingPlanId || sellingPlanId;
          if (planId) cartItem.selling_plan = parseInt(planId, 10);
        }
        items.push(cartItem);
      });

      console.log('[BYO grid submit]', { rhythm, count, activeDiscountCode, items });

      Promise.resolve(activeDiscountCode ? applyDiscountCookie(activeDiscountCode) : null)
        .then(() => fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items,
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname
          })
        }))
        .then(r => { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(data => {
          if (addBtn) {
            addBtn.textContent = addToCartBaseLabel;
            addBtn.disabled = false;
            delete addBtn.dataset.submitting;
          }
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
            cartDrawer.renderContents(data);
          } else {
            window.location.href = window.Shopify.routes.root + 'cart';
          }
        })
        .catch(() => {
          if (addBtn) {
            addBtn.textContent = 'Error';
            setTimeout(() => {
              addBtn.textContent = addToCartBaseLabel;
              addBtn.disabled = false;
              delete addBtn.dataset.submitting;
            }, 2000);
          }
        });
    }

    const addBtn = dRoot.querySelector('[data-byo-add-cart]');
    if (addBtn) addBtn.addEventListener('click', submitCart);

    renderCart();
  }

  /* Bootstrap: init each .choose-path on the page */
  function boot() {
    document.querySelectorAll('.choose-path').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* Re-init on Shopify section reload (theme editor) */
  document.addEventListener('shopify:section:load', boot);
})();
